import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { urls } from "../../endPoints";
import { doPostFile } from "../../../config/fetchWrapper";

export const ImportCustomPlaybookQuestionsAction = createAsyncThunk(
    "importCustomPlaybookQuestions",
    async (arg, { rejectWithValue }) => {
        try {
            const responseData = await doPostFile(urls?.importCustomPlaybookQuestions, arg);
            return responseData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const importCustomPlaybookQuestionsSlice = createSlice({
    name: "importCustomPlaybookQuestions",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        importCustomPlaybookQuestionsReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            };
        },
    },
    extraReducers: {
        [ImportCustomPlaybookQuestionsAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = null;
        },
        [ImportCustomPlaybookQuestionsAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = null;
            state.data = payload;
        },
        [ImportCustomPlaybookQuestionsAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const { importCustomPlaybookQuestionsReset } = importCustomPlaybookQuestionsSlice.actions;
export default importCustomPlaybookQuestionsSlice.reducer;
